import { ContractPaymentData } from "../api/types/contract.types";
import { Milestone, ServiceContract, ServiceRequest } from "./service.type";
import { ServiceContractStatusEnum, ServiceRequestStatusEnum, ServiceRequestTypeEnum } from "../enum/service.enum";

/**
 * Represents the complete state of a contract for business logic calculations
 */
export type ContractState = {
  contractStatus: ServiceContractStatusEnum;
  serviceRequestStatus: ServiceRequestStatusEnum;
  serviceRequestType: ServiceRequestTypeEnum;
  milestones: Milestone[];
  paymentData?: ContractPaymentData | null;
};

/**
 * Helper function to create ContractState from ServiceContract and optional payment data
 */
export const createContractState = (
  contract: ServiceContract,
  paymentData?: ContractPaymentData | null
): ContractState => {
  return {
    contractStatus: contract.status,
    serviceRequestStatus: contract.serviceRequest.status,
    serviceRequestType: contract.serviceRequest.type,
    milestones: contract.milestones,
    paymentData: paymentData ?? null,
  };
};
